import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getCommentTypes = createAsyncThunk('/getCommentTypes',
  async () => {
    const response = await axios.get('/GetCommentTypes');
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

export const getCommentTypeDetails = createAsyncThunk(
  '/getCommentTypeDetails',
  async (id) => {
    const response = await axios.get(`/GetCommentTypeDetails/${id}`);
    return response.data;
  }
);

const commentTypeSlice = createSlice({
  name: 'commentType',
  initialState: {
    loading: false,
    error: '',
    CommentTypes:[],
    commentTypeDescriptions:[],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },
    resetDescriptions(state) {
      state.commentTypeDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },
  extraReducers: {
    [getCommentTypes.pending]: (state) => {
      state.loading = true;
    },
    [getCommentTypes.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getCommentTypes.fulfilled]: (state, action) => {
      state.CommentTypes= action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.commentTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getCommentTypeDetails.pending]: (state) => {
      state.loading = true;
    },
    [getCommentTypeDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getCommentTypeDetails.fulfilled]: (state, action) => {
      state.commentTypeDescriptions = action.payload;
      state.loading = false;
    }
  }
});
export const commentTypeActions = commentTypeSlice.actions;

export default commentTypeSlice;